/*
 * @Author: LiGang
 * @Date: 2026-06-06 00:32:46
 * @LastEditors: LG liganglig@outlook.com
 * @LastEditTime: 2026-06-11 14:27:03
 * @FilePath: /chezhu-h5-dev/config/arrearsConfig.js
 * @Description: 
 * 
 * Copyright (c) 2026 by ${git_name_email}, All Rights Reserved. 
 */
/**
 * 花瓣欠费平台配置
 * 文档: 花瓣 H5 欠费追缴插件
 *
 * 所有可配置参数集中管理，避免魔法值硬编码
 */
// jYa5kDfRbwNHPKS9Rs 测试环境使用，生产发布时需要改为生产环境的appid

// 花瓣分配的应用 ID-测试
// export const arrearsAppId = 'jYa5kDfRbwNHPKS9Rs'

// 花瓣分配的应用 ID-生产
export const arrearsAppId = '2anf9PIsuauR6YtOsN'

// 花瓣分配的密钥 生产（尚未使用）
export const arrearsSecret = '09df888fbfa5e4170e9c236aad9317a0'

// 花瓣分配的密钥 测试（尚未使用）
// export const arrearsSecret = 'bd0429caa53bcca576195f507c511f0f'

// 默认停车场 ID（可在调用时覆盖）
export const arrearsParkingId = ''

// 是否开通追缴功能
export const arrearsIsPaid = true

// 调试模式（上线改 false）
export const arrearsIsDebug = false

// 花瓣插件 CDN 地址
export const arrearsCdnUrl = 'https://cos.petalsdata.com/plugin/arrears-plugin-h5.min.js'
